<template>
    <title-page :title="getCurrentGenre?.name" />
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import { useVodPageStore } from "@/stores/VodPage";

    const VodPageStore = useVodPageStore();
    const {
        getCurrentGenre,
    } = storeToRefs(VodPageStore);
</script>